import { useDashboardScreenshotStore } from "stores/dashboardScreenshot/useDashboardScreenshotStore";

import { WidgetComponentType } from "models/screenshot";

import { useScreenshotContext } from "components/screenshot/hooks";
import { ControlDef } from "components/screenshot/models/controlDefinition";
import {
  ABBREVIATIONS_TOGGLE,
  CHART_FONT_SIZE_PRESETS,
  LEGEND_TOGGLE,
  fontFamilyControl
} from "components/screenshot/models/sharedControlDefs";
import { buildControls } from "components/screenshot/utils/buildScreenshotControls";
import { CHART_WIDGET_TYPES } from "components/shared/charts/hooks/chartWidgetTypes";

const SAM_WIDGET_TYPES = new Set(["sam", "sam-rf-pv"]);

/** SAM-specific control definitions — shares common presets with MPC. */
const SAM_CONTROLS: readonly ControlDef[] = [
  LEGEND_TOGGLE,
  ABBREVIATIONS_TOGGLE,
  ...CHART_FONT_SIZE_PRESETS,
  fontFamilyControl()
];

function useSamChartScreenshotSettingsControls() {
  const { widget } = useScreenshotContext();
  const dashboardWidgets = useDashboardScreenshotStore((s) => s.activeWidgets);
  const dashboardHasSam = dashboardWidgets.some((w) => SAM_WIDGET_TYPES.has(w.type));
  const dashboardHasChart = dashboardWidgets.some((w) => CHART_WIDGET_TYPES.has(w.type));

  const isSam = widget?.widgetComponentType === WidgetComponentType.Sam;
  const isDashboardWithSam =
    widget?.widgetComponentType === WidgetComponentType.Dashboard && dashboardHasSam;

  if (!isSam && !isDashboardWithSam) return [];

  // When the dashboard also has regular charts, the chart hook already provides
  // the legend toggle — skip it here to avoid a duplicate control.
  const defs =
    isDashboardWithSam && dashboardHasChart
      ? SAM_CONTROLS.filter((d) => d.name !== "legendVisible")
      : SAM_CONTROLS;

  return buildControls(defs, { isDashboard: isDashboardWithSam });
}

export default useSamChartScreenshotSettingsControls;
